import { Directive } from '@angular/core';

@Directive({
    selector: '[exl-footer-links-section-head]',
    host: { 'class': 'exl-footer-links-section-head' },
    standalone: true
})
  export class FooterLinksSectionHeadDirective {}
